import { createStyles, getStylesRef } from "@mantine/core"

// -- migrated from app/static/frontend/favorites/stylus/favorites.styl -- //

export const useStyles = createStyles((theme) => ({
    userActionWrapper: {
        height: "100%",
        width: "100%",
        marginTop: "1.25rem",
        display: "flex",
        gap: "1.25rem",
    },
    userActionInWidget: {
        marginTop: "0",
        maxHeight: "unset",
        padding: "1rem",
    },
    userActionListHeader: {
        lineHeight: "initial",
    },
    userActionList: {
        width: "100%",
        minWidth: "15.5rem",
        overflowX: "auto",
        gap: ".75rem",
    },
    userActionContainer: {
        overflowY: "auto",
        gap: ".5rem",

        "::-webkit-scrollbar": {
            width: "0.5rem",
        },

        "::-webkit-scrollbar-track": {
            background: "transparent",
        },

        "::-webkit-scrollbar-thumb": {
            background: "rgba(0, 0, 0, 0.0)",
        },

        ":hover::-webkit-scrollbar-thumb": {
            background: "rgba(0, 0, 0, 0.1)",
            border: "2px solid rgba(0, 0, 0, 0)",
            borderRadius: "1rem",
            backgroundClip: "padding-box",
        },
    },
    userActionItem: {
        alignItems: "center",
        border: `solid 1px ${theme.colors.gray[2]}`,
        cursor: "pointer",
        display: "flex",
        gap: ".75rem",
        height: "2.5rem",
        padding: ".75rem .25rem .75rem .75rem",
        transition: "background-color .2s ease-in-out",

        "&:hover": {
            backgroundColor: theme.colors.violet[1],

            [`& .${getStylesRef("userActionItemButton")}`]: {
                opacity: "1",
            },

            [`& .${getStylesRef("userActionItemText")}, & .${getStylesRef("userActionItemIcon")}`]: {
                color: theme.colors.violet[8],
            },

            [`& .${getStylesRef("userActionItemButtonContainer")}`]: {
                display: "flex",
            },
        },
        "&:active": {
            backgroundColor: theme.colors.violet[1],
        },
    },
    userActionItemIcon: {
        ref: getStylesRef("userActionItemIcon"),
        color: theme.colors.gray[5],
        transition: "color .2s ease-in-out",
        height: ".75rem !important",
        width: ".75rem !important",
    },
    userActionItemText: {
        ref: getStylesRef("userActionItemText"),
        width: "100%",
        fontSize: ".875rem",
        transition: "color .2s ease-in-out",
    },
    userActionItemButtonContainer: {
        ref: getStylesRef("userActionItemButtonContainer"),
        display: "none",
    },
    userActionItemButton: {
        ref: getStylesRef("userActionItemButton"),
        maxHeight: "1.5rem",
        minWidth: "1.5rem",
        padding: "0",
        border: "0",
        transition: "opacity .2s ease-in-out, background-color .2s ease-in-out",
        opacity: "0",

        "&:hover": {
            backgroundColor: theme.colors.gray[1],
        },
    },
    userActionItemButtonIcon: {
        color: theme.colors.gray[9],
        fontSize: ".675rem",
    },
    empty: {
        padding: "1.25rem",
    },
    notClickable: {
        cursor: "unset",

        "&:hover": {
            backgroundColor: "unset",
        },
        "&:active": {
            backgroundColor: "unset",
        },
        "& fa:hover": {
            color: "unset",
        },
    },
}))
